module.exports = __webpack_public_path__ + "static/media/grid.3ebf50bc.png";